import { Stack, Box, Typography, List, ListItem } from "@mui/material";
import { choices, infoToCollect, useInfo, shareInfo} from "../../data/PrivacyPolicy";
import "../../styles/PolicyTermCondition.css";

const PrivatePolicy = () => {
    return (
        <Stack className="policy-box">
            <Box>
                <Typography variant='h6' className="header-weight">A2B Deliver Privacy Notice</Typography>
                <Typography variant='body2' className="sub-text-style common-font-size common-margin-top">This Privacy Notice describes how A2B Deliver ("we," "us," or "our") collects, uses, and shares your personal information when you use our web application (the "App")</Typography>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">Information We Collect</Typography>
                <List className="disc-styles">
                    {infoToCollect.map((data, idx) => (
                        <ListItem key={idx} disablePadding className="sub-header"> 
                            <span className="sub-list-text">{data?.title}</span> <span className="common-font-size">{data?.content}</span>
                        </ListItem>
                    ))}
                </List>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">How We Use Your Information</Typography>
                <List className="disc-styles">
                    {useInfo.map((data, idx) => (
                        <ListItem key={idx} disablePadding className="sub-header"> 
                            <span className="sub-list-text">{data?.title}</span> <span className="common-font-size">{data?.content}</span>
                        </ListItem>
                    ))}
                </List>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">How We Share Your Information</Typography>
                <List className="disc-styles">
                    {shareInfo.map((data, idx) => (
                        <ListItem key={idx} disablePadding className="sub-header"> 
                            <span className="sub-list-text">{data?.title}</span> <span className="common-font-size">{data?.content}</span>
                        </ListItem>
                    ))}
                </List>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">Your Choices</Typography>
                <List className="disc-styles">
                    {choices.map((data, idx) => (
                        <ListItem key={idx} disablePadding className="sub-header"> 
                            <span className="sub-list-text">{data?.title}</span> <span className="sub-text-style common-margin-top common-font-size">{data?.content}</span>
                        </ListItem>
                    ))}
                </List>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">SMS Consent</Typography>
                <Typography variant='body2' className="sub-text-style common-font-size common-margin-top">By registering, you authorize A2B deliver to send text messages containing verification codes for authentication purposes. Message and data rates may apply. Your consent to receive these messages is not a condition of purchase.</Typography>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">Security</Typography>
                <Typography variant='body2' className="sub-text-style common-font-size common-margin-top">We take reasonable measures to protect your information from unauthorized access, use, or disclosure. However, no method of transmission over the Internet or electronic storage is 100% secure.</Typography>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">Children's Privacy</Typography>
                <Typography variant='body2' className="sub-text-style common-font-size common-margin-top">The App is not intended for children under the age of 18, and we do not knowingly collect personal information from children under 18.</Typography>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">Changes To This Privacy Notice</Typography>
                <Typography variant='body2' className="sub-text-style common-font-size common-margin-top">We may update this Privacy Notice from time to time. If we make material changes, we will notify you through the App or by other means.</Typography>
            </Box>
            <Box className="common-margin-top">
                <Typography variant='h6' className="header-weight">Contact Us</Typography>
                <Typography variant='body2' className="sub-text-style common-font-size common-margin-top">If you have any questions about this Privacy Notice, please contact us at a2bdeliver@gmail.com.</Typography>
                <Typography variant='body2' className="sub-text-style common-font-size common-margin-top" sx={{ marginBottom: '2rem' }}>Please note that this is a sample privacy notice. You should consult with an attorney to ensure that your privacy notice complies with applicable laws.</Typography>
            </Box>
        </Stack>
    )
}

export default PrivatePolicy;